import React, {useState} from 'react';
import PropTypes from 'prop-types';
import { useInput } from 'ra-core';

const convertStringToNumber = value => {
    const float = parseFloat(value);

    return isNaN(float) ? null : float;
};

const RangeInput = ({
    format,
    helperText,
    label,
    margin = 'dense',
    onBlur,
    onFocus,
    onChange,
    options,
    parse = convertStringToNumber,
    resource,
    source,
    step,
    min,
    max,
    validate,
    variant = 'filled',
    inputProps: overrideInputProps,
    ...rest
}) => {

    const handleChange = (event) => {
        event.persist();
        event.preventDefault();
        setRangeValue(event.target.value);
    };

    const {
        id,
        input,
        isRequired,
        meta: { error, submitError, touched },
    } = useInput({
        format,
        onBlur,
        onFocus,
        onChange: handleChange,
        parse,
        resource,
        source,
        type: 'range',
        validate,
        ...rest,
    });

    const inputProps = { ...overrideInputProps, step, min, max };
    const [rangeValue, setRangeValue] = useState(max);

    return (
        <>
            <label for={id}>{label}: {rangeValue}</label>
            <input
                variant={variant}
                error={!!(touched && (error || submitError))}
                margin={margin}
                {...options}
                {...input}
                {...inputProps}
                value={rangeValue}
            />
        </>
    );
};

RangeInput.propTypes = {
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    options: PropTypes.object,
    resource: PropTypes.string,
    source: PropTypes.string,
    step: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

RangeInput.defaultProps = {
    options: {},
    step: 'any',
    textAlign: 'right',
};

export default RangeInput;
